import { useEffect, useState } from "react";
import Logo from "../../images/57logo.jpeg";
import { useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";

const QuizList = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [acadamics, setAcadamics] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                let data = { status: 0 };
                let result = await Apiservice.AcadamicsGet(data);

                if (result.success) {
                    setAcadamics(result.data);
                } else {
                    alert(result.message);
                }
            } catch (error) {
                console.log(error);
                alert("Something went wrong");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleManage = (id, topicName) => {
        navigate(`/allquestions/${id}`, {
            state: { topicName }
        });
    };
    const handleQuizAdd = (acadamicId, acadamic) => {
        navigate("/quizadd", {
            state: {
                acadamicId: acadamicId,
                acadamic: acadamic,
            },
        });
    };

    return (
        <div
            className="container-fluid py-2 px-3 px-md-2"
            style={{
                minHeight: "100vh",
                userSelect: "none",
            }}
        >
            {/* Header */}
            <div className="row mb-2">
                <div className="col-12 text-center">
                    <h2 style={{ fontWeight: "700", color: "#1f2937", letterSpacing: "0.5px", }}>
                        Quiz Topics
                    </h2>

                    <p style={{ color: "#6b7280", marginTop: "8px", fontSize: "15px", }} >
                        Select and manage your academic quiz topics
                    </p>
                </div>
            </div>

            {/* Loading Skeleton */}
            {loading ? (
                <div className="row g-4">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <div
                            className="col-12 col-sm-6 col-lg-4"
                            key={item}
                        >
                            <div
                                className="card border-0 shadow-sm h-100"
                                style={{ borderRadius: "18px", overflow: "hidden", }}
                            >
                                <div
                                    className="placeholder-glow"
                                    style={{ height: "200px", background: "#e5e7eb", }}
                                ></div>

                                <div className="card-body">
                                    <p className="placeholder-glow">
                                        <span className="placeholder col-8"></span>
                                    </p>

                                    <p className="placeholder-glow">
                                        <span className="placeholder col-12"></span>
                                        <span className="placeholder col-10"></span>
                                    </p>

                                    <div className="placeholder-glow mt-4">
                                        <span
                                            className="placeholder col-12"
                                            style={{ height: "38px" }}
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {acadamics.length > 0 ? (
                        acadamics.map((a) => (
                            <div
                                key={a.acadamic}
                                className="mb-5 border border-1 border-primary shadow p-md-2 m-md-2 hover"
                            >
                                {/* Academic Heading */}
                                <div className="row mb-3">
                                    <div className="col-10">
                                        <div
                                            style={{ display: "flex", alignItems: "center", gap: "10px", }} >
                                            <div
                                                style={{ width: "5px", height: "28px", background: "#0d6efd", borderRadius: "10px", }}
                                            ></div>

                                            <h4
                                                style={{ margin: 0, fontWeight: "600", color: "#111827", }}
                                            >
                                                {a.acadamic}
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-2 text-end">
                                        <button className="btn btn-sm btn-primary"
                                            onClick={() => handleQuizAdd(a.id, a.acadamic)}
                                        >
                                            Add Quiz
                                        </button>
                                    </div>
                                </div>

                                {/* Exams */}
                                <div className="row g-4">
                                    {a.exams.length > 0 ? (
                                        a.exams.map((topic) => (
                                            <div
                                                className="col-12 col-sm-6 col-lg-4 d-flex"
                                                key={topic.id}
                                            >
                                                <div
                                                    className="card border-0 shadow-sm w-100"
                                                    style={{
                                                        borderRadius: "18px", overflow: "hidden", transition: "0.3s",
                                                    }}
                                                >
                                                    {/* Image */}
                                                    <div
                                                        style={{
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {/* <img
                                                            src={topic.profileImage ? topic.profileImage : Logo}
                                                            alt="Quiz Topic"
                                                            className="card-img-top"
                                                            style={{ height: "190px", objectFit: "cover", }}
                                                        /> */}

                                                        <img
                                                            src={topic.profileImage ? topic.profileImage : Logo}
                                                            alt="Quiz Topic"
                                                            className="card-img-top"
                                                            style={{
                                                                height: "190px",
                                                                width: "100%",
                                                                objectFit: "contain",
                                                                background: "#f5f5f5",
                                                                padding: "5px"
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Content */}
                                                    <div className="card-body d-flex flex-column">
                                                        <h5
                                                            className="text-center mb-3"
                                                            style={{
                                                                fontWeight: "600",
                                                                color: "#0d6efd",
                                                                minHeight: "50px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            {topic.name}
                                                        </h5>

                                                        {/* <p
                                                            className="text-center"
                                                            style={{ color: "#6b7280", fontSize: "14px", flexGrow: 1, }}
                                                        >
                                                            Improve your knowledge and
                                                            practice with this quiz topic.
                                                        </p> */}

                                                        <button
                                                            className="btn btn-sm btn-primary w-100 mt-2"
                                                            style={{
                                                                borderRadius: "10px", fontWeight: "500", padding: "10px",
                                                            }}
                                                            onClick={() =>
                                                                handleManage(topic.id, topic.name)
                                                            }
                                                        >
                                                            Manage
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="col-12">
                                            <div
                                                className="alert alert-light border text-center"
                                                style={{ borderRadius: "12px", }}
                                            >
                                                No exams available
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <div
                                    className="alert alert-light border text-center"
                                    style={{ borderRadius: "14px", padding: "20px", fontWeight: "500", }}                                >
                                    No Academics Available
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default QuizList;
// const [topics, setTopics] = useState([
//     { id: 2, heading: "Incident Response Training" },
//     { id: 3, heading: "Guard and Patrol Training" },
//     { id: 1, heading: "Threat Observation Training" },
// ]);

{/* {topics.length > 0 && topics.map((topic) => (
                    <div className="col-md-4 d-flex" key={topic.id}>
                        <div className="card h-100 shadow-sm border-0">
                            <img
                                src={Logo}
                                alt="Quiz Topic"
                                className="card-img-top"
                                style={{ height: "200px", objectFit: "cover" }}
                            />
                            <div className="card-body d-flex flex-column">
                                <h5 className="card-title text-center text-primary">{topic.heading}</h5>
                                {/* <p className="card-text text-muted text-center">
                                    This is an entry-level security exam designed to improve your knowledge.
                                </p> this is the end of command
                                <div className="mt-auto">
                                    <button
                                        className="btn btn-primary btn-sm w-100"
                                        onClick={() => handleManage(topic.id)}
                                    >
                                        Manage
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))} */}